import { useCallback, useRef } from 'react';
import OrderService from '../../../../../service/OrderService';
import { usePayment } from '../context/PaymentContext';

export const useBankTransfer = (toast) => {
  const {
    amountBankTransfer,
    bankTransferReceipt,
    setAmountBankTransfer,
    setBankTransferReceipt,
    getMaxAmounts,
    loading
  } = usePayment();

  const fileUploadRef = useRef(null);

  const handleAmountChange = useCallback((value, combinePayment, totalPrice) => {
    const maxAmounts = getMaxAmounts();
    let validValue = 0;
    if (combinePayment) {
      validValue = value && value > 0 ? Math.min(parseFloat(value), maxAmounts.maxBankTransfer) : 0;
    } else {
      validValue = totalPrice;
    }
    setAmountBankTransfer(validValue);
  }, [setAmountBankTransfer, getMaxAmounts]);

  const uploadReceipt = useCallback(async (event) => {
    if (event.files[0].size / 1024 / 1024 > 5) {
      fileUploadRef.current?.clear();
      toast?.current?.show({
        severity: "error",
        summary: "Erro",
        detail: "Arquivo muito grande. Máximo 5MB.",
        life: 6000,
      });
      return false;
    }

    try {
      const orderService = new OrderService();
      const res = await orderService.setBankTransferReceipt(event.files[0]);
      setBankTransferReceipt(res.result);

      toast?.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: "Comprovante enviado com sucesso!",
        life: 3000,
      });
    } catch (error) {
      toast?.current?.show({
        severity: "error",
        summary: "Erro",
        detail: "Erro ao enviar comprovante. Tente novamente.",
        life: 6000,
      });
    }
  }, [setBankTransferReceipt, toast]);

  const canProceed = useCallback(() => {
    return amountBankTransfer > 0 ? !!bankTransferReceipt : true;
  }, [amountBankTransfer, bankTransferReceipt]);

  const clearBankTransfer = useCallback(() => {
    setAmountBankTransfer(0);
    setBankTransferReceipt(null);
    fileUploadRef.current?.clear();
  }, [setAmountBankTransfer, setBankTransferReceipt]);

  const removeReceipt = useCallback(() => {
    setBankTransferReceipt(null);
    fileUploadRef.current?.clear();

    toast?.current?.show({
      severity: "info",
      summary: "Removido",
      detail: "Comprovante removido com sucesso!",
      life: 3000,
    });
  }, [setBankTransferReceipt, toast]);

  return {
    amountBankTransfer,
    bankTransferReceipt,
    maxAmount: getMaxAmounts().maxBankTransfer,
    loading,
    fileUploadRef,
    handleAmountChange,
    uploadReceipt,
    canProceed,
    clearBankTransfer,
    removeReceipt,
  };
};
